import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../context/authContext";
import "./Reports.css";
import { renderStatementWithKaTeX } from "../../Status";
import API from "../../Functions/API/api";

function ReportForm() {
  const { user } = useContext(AuthContext);
  const [formData, setFormData] = useState({
    author: { name: user?.username, _id: user?._id },
    subject: "",
    explanation: "",
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user?._id) {
      setMessage("You must be logged in to submit a report ❌");
      return;
    }

    try {
      await API.post("/reports", formData);
      setMessage("Report submitted successfully ✅");
      setFormData({
        author: { name: user.username, _id: user._id },
        subject: "",
        explanation: "",
      });
    } catch (err) {
      setMessage("Failed to submit report ❌");
    }
  };

  // clear message after 5 seconds
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  return (
    <div className="ReportPage">
      <div className="Intro">
        <h1>Inconvenient Stay ?</h1>
        <p>
  If you encounter any problems or malfunctions, we would really appreciate it if you reported them to the MathTounsi staff. Doing so will help create a more user-friendly environment for the whole community.<br />
  Thank you for your contribution in making MathTounsi better!
</p>
        <hr />
      </div>

      <div className="report-form-container">
        <span className="floating-symbol pi">
          {renderStatementWithKaTeX("$\\pi$")}
        </span>
        <span className="floating-symbol sigma">
          {renderStatementWithKaTeX("$\\sum$")}
        </span>
        <span className="floating-symbol infinity">
          {renderStatementWithKaTeX("$\\infty$")}
        </span>
        <span className="floating-symbol sqrt">
          {renderStatementWithKaTeX("$\\sqrt{}$")}
        </span>
        <span className="floating-symbol integral">
          {renderStatementWithKaTeX("$\\int$")}
        </span>
        <span className="floating-symbol plusminus">
          {renderStatementWithKaTeX("$\\pm$")}
        </span>
        <h2>Submit an Issue Report</h2>
        <form onSubmit={handleSubmit} className="report-form">
          <label>Subject</label>
          <input
            type="text"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            required
          />

          <label>Explanation</label>
          <textarea
            name="explanation"
            value={formData.explanation}
            onChange={handleChange}
            rows="5"
            required
          ></textarea>

          <button type="submit" className="btn-submit">
            Submit
          </button>
        </form>

        {message && <p className="message">{message}</p>}
      </div>
    </div>
  );
}

export default ReportForm;
